module.exports = __webpack_public_path__ + "img/21.fd85b714.webp";